var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('loading-page'):_c('policies-form',{attrs:{"details":""},on:{"edit":_vm.onEdit,"close":_vm.onClose}})}
var staticRenderFns = []

export { render, staticRenderFns }